import React from 'react';
import classNames from 'classnames';

import css from './Checkbox.css';

const VARIANTS = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const Checkbox = ({
  checked = false,
  onChange,
  label,
  labelClassName,
  inputClassName,
  textClassName,
  checkmarkClassName,
  size = VARIANTS.MEDIUM,
  disabled,
  ...props
}) => {
  const labelClass = classNames(labelClassName, css.label, {
    [css.largeLabel]: size === VARIANTS.LARGE,
    [css.mediumLabel]: size === VARIANTS.MEDIUM,
    [css.smallLabel]: size === VARIANTS.SMALL,
    [css.labelDisabled]: disabled,
  });
  const inputClasses = classNames(inputClassName, css.checkboxInput);
  const textClasses = classNames(textClassName, css.text);
  const checkmarkClass = classNames(checkmarkClassName, css.checkmark, {
    [css.large]: size === VARIANTS.LARGE,
    [css.medium]: size === VARIANTS.MEDIUM,
    [css.small]: size === VARIANTS.SMALL,
    [css.disabled]: disabled,
  });

  return (
    <label className={labelClass}>
      <span className={textClasses}>{label}</span>
      <input
        className={inputClasses}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      <span className={checkmarkClass}></span>
    </label>
  );
};

export default Checkbox;
